/**
 * 能源类型枚举
 * @enum {number}
 * @readonly
 * @property {number} ELECTRIC - 1 纯电动
 * @property {number} GAS - 2 汽油
 * @property {number} PLUGINHYBIRDELECT - 3 插电式混动
 * @property {number} REEV - 4 增程式混动
 * @property {number} HYBIRDELECT - 5 油电混动
 * @property {number} DIESEL - 6 柴油
 * @property {number} GASOLINE - 7 天然气
 * @property {number} OTHER - 8 其他
 */
// 枚举
export const ENERY_TYPE_ENUM = {
  ELECTRIC: 1, // 纯电动
  GAS: 2, // 汽油
  PLUGINHYBIRDELECT: 3, // '插电式混动',
  REEV: 4, // '增程式混动',
  HYBIRDELECT: 5, // '油电混动',
  DIESEL: 6, // '柴油',
  GASOLINE: 7, // '天然气',
  OTHER: 8, // '其他',
}

// 显示 纯电续航里程： 能源类型为 纯电动、插电式混动、增程式混动、油电混合
export const judgePureElectricDrivingRange = (energyType) => {
  return [
    ENERY_TYPE_ENUM.ELECTRIC,
    ENERY_TYPE_ENUM.PLUGINHYBIRDELECT,
    ENERY_TYPE_ENUM.REEV,
  ].includes(energyType)
}

// 显示 综合油耗： 能源类型为 汽油、插电式混动、增程式混动、油电混合、柴油、天然气
export const judgeFuelConsumption = (energyType) => {
  return [
    ENERY_TYPE_ENUM.GAS,
    ENERY_TYPE_ENUM.HYBIRDELECT,
    ENERY_TYPE_ENUM.DIESEL,
    ENERY_TYPE_ENUM.PLUGINHYBIRDELECT,
    ENERY_TYPE_ENUM.REEV,
    ENERY_TYPE_ENUM.GASOLINE,
  ].includes(energyType)
}
